import nurseIcon from "./RpmAssets/PNGIcons/nurse.png";
import telephoneCall from "./RpmAssets/PNGIcons/telephone-call.png";
import videoCam from "./RpmAssets/PNGIcons/video-camera.png";
import ambulance from "./RpmAssets/PNGIcons/Repeat Grid 1.png";
import insurance from "./RpmAssets/PNGIcons/Icon map-insurance-agency.svg";
import friends from "./RpmAssets/PNGIcons/Icon awesome-user-friends.svg";
import doctor from "./RpmAssets/PNGIcons/Icon map-doctor.svg";
import profile from "./RpmAssets/PNGIcons/Icon metro-profile.svg";
import fileRx from "./RpmAssets/PNGIcons/Icon awesome-file-prescription.svg";
import uknknownFile from "./RpmAssets/PNGIcons/Icon awesome-file.svg";
import medicalFile from "./RpmAssets/PNGIcons/Icon awesome-file-medical-alt.svg";
import addFile from "./RpmAssets/PNGIcons/Icon awesome-file-medical.svg";
import locationRed from "./RpmAssets/PNGIcons/locationRed.png";
import liveLocation from "./RpmAssets/PNGIcons/currentLocation.png";
import checkSmall from "./check_small.svg";
import crossSmall from "./cross_small.svg";
import departmentProfileSample from "./department_profile_sample.png";
import generalCommunicatiion from "./general_communication.svg";
import technicalSupport from "./technical_support.svg";
import nav_icon_department_profile from "./NavbarIcons/apps-add.svg";
import c2mdMain from "./HomepageAssets/Footer/c2mdMain.png";
import hangaHospitalImage from "./ganga/hos_image.jpg";
import bookAppointment from "./dashboardv2/responsive/book_appointment.svg";
import myAppointments from "./dashboardv2/responsive/ic_toc.svg";
import myHealthRecords from "./dashboardv2/responsive/health_records.svg";
import ganga from "./dashboardv2/responsive/ganga.svg";
import Aravind from "./dashboardv2/responsive/about_hospital.png";
import uploadReportIcon from "./upload_button_icon.svg";
import Dial from "./common/Dial.icon";
import User from "./common/User.icon";
import Add from "./common/Add.icon";
import EyeIcon from "./common/Eye.icon";
import AddRoundIcon from "./common/Add_Round.icon";
import ArrowBack from "./common/ArrowBack.icon";

export const Assets = {
  DialIcon: Dial,
  UserIcon: User,
  AddIcon: Add,
  EyeIcon,
  AddRoundIcon,
  ArrowBack,
  nurseIcon,
  telephoneCall,
  videoCam,
  ambulance,
  insurance,
  friends,
  profile,
  fileRx,
  uknknownFile,
  medicalFile,
  addFile,
  doctor,
  locationRed,
  liveLocation,
  checkSmall,
  crossSmall,
  departmentProfileSample,
  generalCommunicatiion,
  technicalSupport,
  nav_icon_department_profile,
  c2mdMain,
  hangaHospitalImage,
  dashboard: {
    bookAppointment,
    myAppointments,
    myHealthRecords,
    ganga,
    Aravind,
    uploadReportIcon,
  },
};
